import { ProfileSettingsService } from './../../../services/shared/profile-settings/profile-settings.service';
import { environment } from 'src/environments/environment';
import {
  hexToRGB,
  hexToRGBNumber,
  jsonDeepParse,
} from 'src/app/functions/shared-functions';
import { ThemeService } from './../../../controls/theme/services/theme.service';
import { MyJourneyService } from './../../my-journey/services/my-journey/my-journey.service';
import { TranslateService } from '@ngx-translate/core';
import {
  Component,
  OnInit,
  NgZone,
  ChangeDetectorRef,
  Input,
  HostListener,
  ElementRef,
} from '@angular/core';
import { SessionService } from 'src/app/services/session/session.service';
import { Session } from 'src/app/classes/session/session';
import { FirebaseMessagingService } from 'src/app/services/firebase-messaging/firebase-messaging.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login/login.service';
import { ProfileSettingsComponent } from '../profile-settings/profile-settings.component';
import { jsonParse } from 'src/app/app.component';
import { LoginComponentV2 } from '../../login-v2/login.component';
import { Meta, Title } from '@angular/platform-browser';
import { ChangePasswordComponent } from '../../login/components/change-password/change-password.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [MyJourneyService],
})
export class NavbarComponent implements OnInit {
  email = 'enquiry@manpowergroup.com';

  openDropdown = false;

  session = new Session();
  my_joureny;
  public notifications = [];
  navbarOpen = false;
  user_id;
  login_details;
  my_journey: boolean = false;
  user_info: any = {};
  masters = {
    countrylist: [],
  };
  title = 'Tallite';
  logo;
  themes = [];
  language_code_array = [];
  language_list: any = [];
  selected_lang = 'English';
  token;
  @Input() login_flag;
  @Input() sidebarref;
  system_theme: any = {};
  socialIcons = [];
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  portal_details: any;
  mobile_header = {
    language_open: false,
    userinfo_open: false,
    sidenav_open: false,
  };
  private lastScrollPosition = 0;
  private isNavbarVisible = true;
  @HostListener('window:scroll', [])
  onScroll(): void {
    const currentScrollPosition = window.pageYOffset;
    if (this.lastScrollPosition == 0) {
      // this.showNavbar();
    } else if (currentScrollPosition > this.lastScrollPosition) {
      // this.hideNavbar();
    } else {
      // this.showNavbar();
    }

    this.lastScrollPosition = currentScrollPosition;
  }

  // private hideNavbar(): void {
  //   if (this.isNavbarVisible) {
  //     const navbar = document.querySelector('.top-header');
  //     navbar.classList.add('hidden');
  //     this.isNavbarVisible = false;
  //   }
  // }

  // private showNavbar(): void {
  //   if (!this.isNavbarVisible) {
  //     const navbar = document.querySelector('.top-header');
  //     navbar.classList.remove('hidden');
  //     this.isNavbarVisible = true;
  //   }
  // }
  constructor(
    public session_svc: SessionService,

    public notification: FirebaseMessagingService,
    private ngZone: NgZone,
    public dialog: MatDialog,
    private router: Router,
    public login_service: LoginService,
    private change_detector: ChangeDetectorRef,
    private translate: TranslateService,
    private my_journey_srv: MyJourneyService,
    private theme_srv: ThemeService,
    private metaTagService: Meta,
    private title_srv: Title,
    private profile_settings: ProfileSettingsService
  ) {
    try {
      this.portal_details = jsonParse(localStorage.getItem('portal_details'));
      if (
        this.portal_details &&
        this.portal_details.portalSettings &&
        this.portal_details.portalSettings.topNavbarlink &&
        this.portal_details.portalSettings.topNavbarlink.length
      ) {
        try {
          this.socialIcons =
            this.portal_details.portalSettings.topNavbarlink.filter((r) => {
              return r.isSocialProperty;
            });

          this.portal_details.portalSettings.topNavbarlink =
            this.portal_details.portalSettings.topNavbarlink.filter(
              (d) => !d.isSocialProperty
            );
        } catch (Err) {}
      }
      this.preparePortal(this.portal_details);
    } catch (err) {
      console.log(err);
    }

    try {
      let theme = jsonParse(localStorage.getItem('applicationTheme'));
      if (theme) {
        this.theme_srv.setActiveTheme(theme);
      }
    } catch (err) {
      console.log(err);
    }

    let list = jsonParse(localStorage.getItem('languagelist'));
    // console.log(list)
    if (list && list.length) {
      this.language_list = list;
      localStorage.setItem('languagelist', JSON.stringify(this.language_list));
      this.language_list.forEach((lng) => {
        this.language_code_array.push(lng.languageCode);
      });
      if (this.language_code_array.length > 0) {
        this.translate.addLangs(this.language_code_array);
        if (localStorage.getItem('locale')) {
          const browserLang = localStorage.getItem('locale') || 'EN';
          this.language_list.forEach((lng) => {
            if (lng.lngId == parseInt(browserLang)) {
              this.selected_lang = lng.languageName;
            }
          });
          this.translate.use(browserLang);

          this.login_service.getAllLabels(browserLang).subscribe((res) => {
            let labels = res;

            let keys = Object.keys(labels);
            keys.forEach((k) => {
              if (typeof labels[k] == 'string') {
                let str = labels[k];
                str = str.replace(/[\\]+\\"/g, '\\"');
                str = str.replace(/\\&amp;#34;/g, '');
                str = str.replace(/[\t]/g, '    ');
                str = this.replaceNbsps(str);
                labels[k] = str;
              } else if (typeof labels[k] == 'object') {
                let nested_labels = labels[k];
                let nested_keys = Object.keys(labels[k]);
                nested_keys.forEach((ky) => {
                  if (typeof nested_labels[ky] == 'string') {
                    let str = nested_labels[ky];
                    str = str.replace(/[\\]+\\"/g, '\\"');
                    str = str.replace(/\\&amp;#34;/g, '');
                    str = str.replace(/[\t]/g, '    ');
                    str = str.replace(/&nbsp;/g, ' ');
                    str = str.replace(/\s/g, ' ');
                    str = this.replaceNbsps(str);
                    nested_labels[ky] = str;
                  }
                });
              }
            });

            let lngId = localStorage.getItem('lngId');
            this.translate.setTranslation(browserLang, labels);
            this.language_list.forEach((lng) => {
              if (lng.lngId == lngId) {
                this.selected_lang = lng.languageName;
                if (lng.rtlFlag == 1) {
                  this.setRTL();
                } else {
                  // this.setLTR();
                }
              }
            });
          });
        } else {
          this.language_list.forEach((lang) => {
            let id;
            let lng_name;
            let defaults = localStorage.getItem('lngId');
            if (lang.languageCode == defaults) {
              let browserLang = lang.languageCode;
              id = lang.lngId;
              lng_name = lang.languageName;
              // localStorage.setItem('locale', browserLang)
              // localStorage.setItem('lngId', id)
              this.translate.use(browserLang);
              if (true) {
                localStorage.setItem('locale', browserLang);
                this.selected_lang = lng_name;
                localStorage.setItem('lngId', id);
                this.login_service
                  .getAllLabels(browserLang)
                  .subscribe((res) => {
                    let labels = res;

                    let keys = Object.keys(labels);
                    keys.forEach((k) => {
                      if (typeof labels[k] == 'string') {
                        let str = labels[k];
                        str = str.replace(/[\\]+\\"/g, '\\"');
                        str = str.replace(/\\&amp;#34;/g, '');
                        str = str.replace(/[\t]/g, '    ');
                        str = this.replaceNbsps(str);
                        labels[k] = str;
                      } else if (typeof labels[k] == 'object') {
                        let nested_labels = labels[k];
                        let nested_keys = Object.keys(labels[k]);
                        nested_keys.forEach((ky) => {
                          if (typeof nested_labels[ky] == 'string') {
                            let str = nested_labels[ky];
                            str = str.replace(/[\\]+\\"/g, '\\"');
                            str = str.replace(/\\&amp;#34;/g, '');
                            str = str.replace(/[\t]/g, '    ');
                            str = str.replace(/&nbsp;/g, ' ');
                            str = str.replace(/\s/g, ' ');
                            str = this.replaceNbsps(str);
                            nested_labels[ky] = str;
                          }
                        });
                      }
                    });

                    let lngId = localStorage.getItem('lngId');
                    this.translate.setTranslation(browserLang, labels);
                    this.language_list.forEach((lng) => {
                      if (lng.id == lngId) {
                        this.selected_lang = lng.title;
                        if (lng.rtlflag == 1) {
                          this.setRTL();
                        } else {
                          // this.setLTR();
                        }
                      }
                    });
                  });
              }
            }
          });
        }
      }

      // this.language_list.forEach(element => {
      //   this.language_code_array.push(element.id);
      // });
      // this.ngAfterViewInit()
    }
  }

  ngOnInit() {
    // this.showNavbar()
    const browserLang = localStorage.getItem('locale') || 'EN';
    this.translate.use(browserLang);
    this.theme_srv.setLightTheme();
    this.themes = this.theme_srv.getAvailableThemes();
    this.session_svc.session.subscribe((res) => {
      this.session = res;
      if (this.session && this.session.userId) {
        this.user_id = this.session.userId;
      }
      if (this.session && this.session.token) {
        this.token = this.session.token;
      } else {
        this.token = null;
      }
      if (!this.session) {
        this.user_id = 0;
      }
    });
    this.session_svc.my_journey_details.subscribe((res) => {
      if (res && res['myJourney']) {
        this.my_joureny = res['myJourney'];
      }
    });
    this.getIPAdress();
    if (this.login_flag) {
    }
  }

  checkMyJourney() {
    this.my_journey_srv.getMyJourneyDetails({}).subscribe((res) => {
      if (res && res['data'] && res['data'].myJourney) {
        this.my_journey = true;
      } else {
        this.my_journey = false;
      }
    });
  }
  closeNav() {
    this.navbarOpen = false;
    this.mobile_header.sidenav_open = false;
    this.mobile_header.userinfo_open = false;
  }
  activeTheme(t) {
    this.theme_srv.setActiveTheme(t);
  }
  prepareTheme(data) {
    if (data) {
      let theme: any = {
        name: 'system',
        properties: {},
      };

      Object.keys(data).forEach((k) => {
        try {
          // console.log(k)
          if (typeof data[k] != 'number' && data[k] && data[k].includes('#')) {
            if (
              k != '--tallite-header-background' &&
              k != '--tallite-header-hover-background'
            ) {
              if (theme.properties) {
                theme['properties'][k] = hexToRGB(data[k]);
              } else {
                theme.properties = {};
                theme['properties'][k] = hexToRGB(data[k]);
              }
            } else {
              if (theme.properties) {
                theme['properties'][k] = hexToRGBNumber(data[k]);
              } else {
                theme.properties = {};
                theme['properties'][k] = hexToRGBNumber(data[k]);
              }
            }
          } else {
            if (theme.properties) {
              theme['properties'][k] = data[k];
            } else {
              theme.properties = {};
              theme['properties'][k] = data[k];
            }
          }
        } catch (err) {
          console.log(err);
        }
      });

      return theme;
    } else {
      let t = this.theme_srv.getAvailableThemes();
      if (t.length) {
        return t[0];
      }
    }
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  getIPAdress() {
    this.login_service.getip().subscribe((res) => {
      this.user_info = res;
      localStorage.setItem('getipobject', JSON.stringify(this.user_info));
      this.getMasters();
    });
  }

  login() {
    const dialog = this.dialog.open(LoginComponentV2, {
      disableClose: true,
      panelClass: 'TM-Dialog',
      width: '30%',
    });
    dialog.afterClosed().subscribe((result) => {
      //this.router.navigate(['/jobs']);
    });
  }

  logout() {
    // this.sidebarref(null, null)
    this.session_svc.logout();
  }

  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
      width: '40%',
      panelClass: 'JS-dialog',
    });
  }

  userMenuOpen = false;
  mobileMenuOpen = false;

  getUserInitial(): string {
    if (this.session && this.session.firstName) {
      return this.session.firstName.charAt(0).toUpperCase();
    }
    return 'U';
  }

  toggleUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
    console.log('User menu toggled:', this.userMenuOpen);
    console.log('Session:', this.session);
    console.log('Session token:', this.session?.token);
  }

  closeUserMenu() {
    this.userMenuOpen = false;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    this.lockBodyScroll(this.mobileMenuOpen);
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
    this.lockBodyScroll(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const userSection = target.closest('.user-profile-area');
    
    if (!userSection && this.userMenuOpen) {
      this.userMenuOpen = false;
    }
  }

  getProfileSettings() {
    // this.router.navigate(['edit-profile']);
    if (this.sidebarref) {
      this.sidebarref(null, null, { checkForResume: 1 });
    }
    // const dialog = this.dialog.open(ProfileSettingsComponent, {
    //   width: '500px',
    //   disableClose: true,
    //   panelClass:"TM-Dialog"
    // });
  }

  preparePortal(data) {
    let object = data;
    if (object) {
      if (object.portalFeviconIcon && object.portalFeviconIcon.length) {
        try {
          let el: any = document.getElementById('appIcon');
          if (el) {
            el.href =
              'https://storage.googleapis.com/ezeone/icanrefer/' +
              object.portalFeviconIcon[0].cdnPath;
          }
        } catch (err) {
          console.log(err);
        }
        // this.favIcon.href = 'https://storage.googleapis.com/ezeone/icanrefer/' + this.portal_details.banners[0].cdnPath;
      }
      if (object.portalTitle && object.portalTitle != '') {
        this.title_srv.setTitle(object.portalTitle);
      }
    }
    if (data && data.portalSettings) {
      let object = data.portalSettings;
      if (object) {
        if (object.portalFeviconIcon && object.portalFeviconIcon.length) {
          try {
            let el: any = document.getElementById('appIcon');
            if (el) {
              el.href =
                'https://storage.googleapis.com/ezeone/icanrefer/' +
                object.portalFeviconIcon[0].cdnPath;
            }
          } catch (err) {
            console.log(err);
          }
          // this.favIcon.href = 'https://storage.googleapis.com/ezeone/icanrefer/' + this.portal_details.banners[0].cdnPath;
        }
      }
    }
    if (data && data.title != '') {
      this.title_srv.setTitle(data.title);
    }
  }

  getMasters() {
    // this.master_svc.getIpAddress().subscribe(res => {
    //   if (res) {
    let res = {};
    var retrievedObject = localStorage.getItem('getipobject');
    this.profile_settings.countryMaster().subscribe((masters) => {
      if (masters && masters['data']) {
        masters['data'] = jsonDeepParse(masters['data']);
        if (
          masters['data'].portalThemeSettings &&
          masters['data'].portalThemeSettings != ''
        ) {
          let theme = this.prepareTheme(masters['data'].portalThemeSettings);
          console.log(theme);
          this.theme_srv.setActiveTheme(theme);
          localStorage.setItem('applicationTheme', JSON.stringify(theme));
        }
        sessionStorage.setItem('country', JSON.stringify(masters['data']));

        if (
          masters['data'].careerPortalName &&
          masters['data'].careerPortalName != ''
        ) {
          this.title_srv.setTitle(masters['data'].careerPortalName);
        }

        if (masters['data'].careerPortalConfig) {
          this.portal_details = jsonDeepParse(
            masters['data'].careerPortalConfig
          );

          if (
            this.portal_details &&
            this.portal_details.portalSettings &&
            this.portal_details.portalSettings.topNavbarlink &&
            this.portal_details.portalSettings.topNavbarlink.length
          ) {
            try {
              this.socialIcons =
                this.portal_details.portalSettings.topNavbarlink.filter((r) => {
                  return r.isSocialProperty;
                });

              this.portal_details.portalSettings.topNavbarlink =
                this.portal_details.portalSettings.topNavbarlink.filter(
                  (d) => !d.isSocialProperty
                );
            } catch (Err) {}
          }

          if (
            this.portal_details &&
            this.portal_details.portalSettings &&
            this.portal_details.portalSettings.banners &&
            this.portal_details.portalSettings.banners.length
          ) {
            this.logo = this.portal_details.portalSettings.banners[0].cdnPath;
          } else if (
            masters['data'].companyLogo &&
            masters['data'].companyLogo != ''
          ) {
            let data = jsonDeepParse(masters['data'].companyLogo);
            if (data && data.length) {
              this.logo = data[0].cdnPath;
            }
          }
          this.preparePortal(this.portal_details);
          if (this.portal_details) {
            let pd = this.portal_details.portalSettings;
            if (
              pd &&
              pd.portalBackgroundImageArr &&
              pd.portalBackgroundImageArr.length
            ) {
              this.portal_details['portalBackgroundImage'] =
                pd.portalBackgroundImageArr[0].cdnPath;
              console.log(this.portal_details);
            }
          }
          localStorage.setItem(
            'portal_details',
            JSON.stringify(this.portal_details)
          );
        } else if (
          masters['data'].companyLogo &&
          masters['data'].companyLogo != ''
        ) {
          let data = jsonDeepParse(masters['data'].companyLogo);
          if (data && data.length) {
            this.logo = data[0].cdnPath;
          }
        }
        // this.favIcon.href = 'https://storage.googleapis.com/ezeone/icanrefer/da4bcbda-9455-42e8-9ab3-a299a5e62d18.png';
      }
      if (masters && masters['data'] && masters['data'].countryList) {
        this.masters.countrylist = masters['data'].countryList;
      }
      if (masters && masters['data'] && masters['data']['languageList']) {
        this.language_list = masters['data']['languageList'];

        let list = localStorage.getItem('languagelist');
        if (list && list.length) {
          localStorage.setItem(
            'languagelist',
            JSON.stringify(this.language_list)
          );
        } else {
          localStorage.setItem(
            'languagelist',
            JSON.stringify(this.language_list)
          );
          this.language_list.forEach((lng) => {
            this.language_code_array.push(lng.languageCode);
          });
          if (this.language_code_array.length > 0) {
            this.translate.addLangs(this.language_code_array);
            if (localStorage.getItem('locale')) {
              const browserLang = localStorage.getItem('locale') || 'EN';
              this.language_list.forEach((lng) => {
                if (lng.lngId == parseInt(browserLang)) {
                  this.selected_lang = lng.languageName;
                }
              });
              this.translate.use(browserLang);

              this.login_service.getAllLabels(browserLang).subscribe((res) => {
                let labels = res;

                let keys = Object.keys(labels);
                keys.forEach((k) => {
                  if (typeof labels[k] == 'string') {
                    let str = labels[k];
                    str = str.replace(/[\\]+\\"/g, '\\"');
                    str = str.replace(/\\&amp;#34;/g, '');
                    str = str.replace(/[\t]/g, '    ');
                    str = this.replaceNbsps(str);
                    labels[k] = str;
                  } else if (typeof labels[k] == 'object') {
                    let nested_labels = labels[k];
                    let nested_keys = Object.keys(labels[k]);
                    nested_keys.forEach((ky) => {
                      if (typeof nested_labels[ky] == 'string') {
                        let str = nested_labels[ky];
                        str = str.replace(/[\\]+\\"/g, '\\"');
                        str = str.replace(/\\&amp;#34;/g, '');
                        str = str.replace(/[\t]/g, '    ');
                        str = str.replace(/&nbsp;/g, ' ');
                        str = str.replace(/\s/g, ' ');
                        str = this.replaceNbsps(str);
                        nested_labels[ky] = str;
                      }
                    });
                  }
                });

                let lngId = localStorage.getItem('lngId');
                this.translate.setTranslation(browserLang, labels);
                this.language_list.forEach((lng) => {
                  if (lng.lngId == lngId) {
                    this.selected_lang = lng.languageName;
                    if (lng.rtlFlag == 1) {
                      this.setRTL();
                    } else {
                      // this.setLTR();
                    }
                  }
                });
              });
            } else {
              this.language_list.forEach((lang) => {
                let id;
                let lng_name;
                let defaults = masters['data'] && masters['data'].lng;
                if (lang.languageCode == defaults) {
                  let browserLang = masters['data'].lng;
                  id = lang.lngId;
                  lng_name = lang.languageName;
                  // localStorage.setItem('locale', browserLang)
                  // localStorage.setItem('lngId', id)
                  this.translate.use(browserLang);
                  if (true) {
                    localStorage.setItem('locale', browserLang);
                    this.selected_lang = lng_name;
                    localStorage.setItem('lngId', id);
                    this.login_service
                      .getAllLabels(browserLang)
                      .subscribe((res) => {
                        let labels = res;

                        let keys = Object.keys(labels);
                        keys.forEach((k) => {
                          if (typeof labels[k] == 'string') {
                            let str = labels[k];
                            str = str.replace(/[\\]+\\"/g, '\\"');
                            str = str.replace(/\\&amp;#34;/g, '');
                            str = str.replace(/[\t]/g, '    ');
                            str = this.replaceNbsps(str);
                            labels[k] = str;
                          } else if (typeof labels[k] == 'object') {
                            let nested_labels = labels[k];
                            let nested_keys = Object.keys(labels[k]);
                            nested_keys.forEach((ky) => {
                              if (typeof nested_labels[ky] == 'string') {
                                let str = nested_labels[ky];
                                str = str.replace(/[\\]+\\"/g, '\\"');
                                str = str.replace(/\\&amp;#34;/g, '');
                                str = str.replace(/[\t]/g, '    ');
                                str = str.replace(/&nbsp;/g, ' ');
                                str = str.replace(/\s/g, ' ');
                                str = this.replaceNbsps(str);
                                nested_labels[ky] = str;
                              }
                            });
                          }
                        });

                        let lngId = localStorage.getItem('lngId');
                        this.translate.setTranslation(browserLang, labels);
                        this.language_list.forEach((lng) => {
                          if (lng.id == lngId) {
                            this.selected_lang = lng.title;
                            if (lng.rtlflag == 1) {
                              this.setRTL();
                            } else {
                              // this.setLTR();
                            }
                          }
                        });
                      });
                  }
                }
              });
            }
          }
        }

        // this.language_list.forEach(element => {
        //   this.language_code_array.push(element.id);
        // });
        // this.ngAfterViewInit()
      }
    });
    //   }
    // })
  }
  setRTL() {
    document.head.innerHTML +=
      '<style>*{text-align: right;unicode-bidi: bidi-override;direction: RTL;}</style>';
  }
  setLTR() {
    document.head.innerHTML +=
      '<style>*{text-align: left;unicode-bidi: unset;direction: LTR;}</style>';
  }
  replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(160), 'g');
    return str.replace(re, ' ');
  }
  changeLang(language) {
    this.selected_lang = language.languageName;
    let lngcode: string = language.languageCode;
    localStorage.setItem('lngId', language.lngId);
    localStorage.setItem('locale', language.languageCode);
    this.translate.use(language.languageCode);
    window.location.reload();
  }

  menuBtnActive = false;
  showtoggleNav = false;

  toggleMenuBtn(): void {
    this.menuBtnActive = !this.menuBtnActive;
    this.showtoggleNav = !this.showtoggleNav;
    this.lockBodyScroll(this.showtoggleNav);
  }

  lockBodyScroll(lock: boolean): void {
    document.body.style.overflow = lock ? 'hidden' : '';
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  ngOnDestroy(): void {
    this.lockBodyScroll(false);
  }
}
